import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { tenantActions } from '../../redux/tenant.actions';
import { getRentalOfferStatus, showSuccesToast } from '../helpers';
import { useDispatch } from 'react-redux';
import moment from 'moment';

const RentalStatusTable = ({ ten = [], flowId = '' ,buttonText,onRightClick, is_renewed}) => {
  console.log("teanats", ten)
  const dispatch = useDispatch()
  return (
    <View style={styles.card}>
      <View style={{flexDirection:"row",justifyContent:"space-between",marginBottom:10}}>
      <Text style={styles.title}>{is_renewed ? 'Renewal Offer Status' : 'Rental Offer Status'}</Text>
      <TouchableOpacity
                onPress={() => {onRightClick() }}
                style={styles.nudgeButton}>
                <Text style={styles.nudgeText}>{buttonText}</Text>
              </TouchableOpacity>
      </View>
      <ScrollView horizontal showsHorizontalScrollIndicator={true} contentContainerStyle={{ minWidth: '100%' }}>

      <View style={styles.table}>
        {/* Header */}
        <View style={[styles.row, styles.headerRow]}>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Tenant</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Status</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Sent On</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Accepted On</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Nudge</Text>
          </View>
        </View>

        {/* Rows */}
        {ten.map((tenant, index) => (
          <View key={index} style={styles.row}>
            <View style={styles.cell}>
              <Text>{tenant?.app_user?.user?.first_name} {tenant?.app_user?.user?.last_name}</Text>
            </View>

            <View style={styles.cell}>
              <View
                style={[
                  styles.statusContainer,
                  { backgroundColor: getRentalOfferStatus(tenant?.rental_offer_status).backgroundColor },
                ]}
              >
                <Text style={{
                  color: getRentalOfferStatus(tenant?.rental_offer_status).color,
                  fontSize: 14,
                  textAlign: "center"
                }}>
                  {getRentalOfferStatus(tenant?.rental_offer_status).Text}
                </Text>
              </View>
            </View>

            <View style={styles.cell}>
              <Text>{moment(tenant.rental_offer_sent_at).format('DD/MM/YYYY') || "-"}</Text>
            </View>

            <View style={styles.cell}>
              <Text>
                {tenant.rental_offer_accepted_at ? moment(tenant.rental_offer_accepted_at).format('DD/MM/YYYY')
                  : '-'}</Text>
            </View>

            <View style={styles.cell}>
              <TouchableOpacity
                onPress={() => {
                  dispatch(tenantActions.rtrReminder(
                    { "flow_id": flowId, "open_flow_sub_tenant_id": [tenant?.app_user_id] }
                    , flowId, () => {
                      showSuccesToast('Reminder sent successfully!')
                    }, "/openflow/send-rental-offer?"))
                }}
                style={styles.nudgeButton}>
                <Text style={styles.nudgeText}>NUDGE</Text>
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    padding: 16,
    backgroundColor: 'white',
    borderRadius: 12,
    elevation: 2,
    marginTop: 10
  },
  title: {
    fontSize: 16,
    color: '#3f51b5',
    fontWeight: '600',
    marginBottom: 12,
  },
  table: {
    minWidth: 980, // Ensures horizontal scroll works on smaller screens
    width: '100%',
    overflow:"scroll"
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#ddd',
    paddingVertical: 12,
  },
  headerRow: {
    backgroundColor: '#f5f5f5',
  },
  cell: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  headerText: {
    fontWeight: '600',
  },
  statusContainer: {
    borderRadius: 12,
    paddingVertical: 4,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',

  },
  nudgeButton: {
    backgroundColor: '#9b5de5',
    paddingHorizontal: 16,
    paddingVertical: 6,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
  nudgeText: {
    color: 'white',
    fontWeight: '600',
  },
});

export default RentalStatusTable;
